'use client'
import { LicenseInfo } from '@mui/x-license'

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENCE_KEY as string)

export default function MuiXLicense() {
  return null
}